import React from 'react';

const Footer = () => {
    return <footer>
        <div className="container">
            <div className="d-flex">
                <div className="copyright">Copyright 2024 tattookolin.cz</div>
                <div className="socials">
                    <a href="https://www.facebook.com/tetovani.kolin" target="_blank" rel="noreferrer" >
                        <img src="./fb.svg" alt="Facebook" width="49" />
                    </a>
                </div>
            </div>
        </div>
    </footer>
}


export default Footer;